import { createRouter, createWebHashHistory } from "vue-router";
import store from '@/store/index.js';
import Login from "@/views/auth/Login.vue";
import ForgotPassword from "@/views/auth/ForgotPassword.vue";
import ResetPassword from "@/views/auth/ResetPassword.vue";
import Profile from "@/views/auth/Profile.vue";

//dashboard
import Dashboard from "@/views/Dashboard.vue";

// schools
import Schools from "@/views/Schools/Index.vue";
import CreateSchool from "@/views/Schools/Create.vue";
import ViewSchool from "@/views/Schools/View.vue";

// users
import Users from "@/views/user/Index.vue";
import CreateUser from "@/views/user/Create.vue";

// configurtaions
import Districts from "@/views/configuration/District.vue"
import Stages from "@/views/configuration/Stage.vue"

// dynamic form
import Forms from "@/views/configuration/DynamicForm/Index.vue";
import CreateForm from "@/views/configuration/DynamicForm/Create.vue";

// session forms
import SessionForms from "@/views/SessionForms/Index.vue";
import SessionFormView from "@/views/SessionForms/View.vue";

// Attendance
import Attendance from "@/views/attendance/Index.vue";

// Reminders
import Reminders from "@/views/Reminders.vue";

const routes = [

    //dashboards

    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard
    },


    {
        path: "/",
        name: "login",
        component: Login,
    },
    {
        path: "/forgot_password",
        name: "ForgotPassword",
        component: ForgotPassword,
    },
    {
        path: "/reset-password/:email_id",
        name: "ResetPassword",
        component: ResetPassword,
    },

    {
        path: "/profile",
        name: "profile",
        component: Profile,
    },
    //schools
    {
        path: "/schools",
        name: "Schools.Index",
        component: Schools,
    },
    {
        path: "/schools/create",
        name: "Schools.Create",
        component: CreateSchool,
    },

    {
        path: "/schools/:school_id/edit",
        name: "School.Edit",
        component: CreateSchool,
    },
    {
        path: "/schools/:school_id/view",
        name: "School.View",
        component: ViewSchool,
    },

    //Users
    {
        path: "/users",
        name: "Users.Index",
        component: Users,
    },
    {
        path: "/users/create",
        name: "Users.Create",
        component: CreateUser,
    },

    {
        path: "/users/:user_id/edit",
        name: "User.Edit",
        component: CreateUser,
    },

    // configuration
    {
        path: "/districts",
        name: "Districts",
        component: Districts,
    },
    {
        path: "/stages",
        name: "Stages",
        component: Stages,
    },
    //Dynamic forms
    {
        path: "/forms",
        name: "Forms.Index",
        component: Forms,
    },
    {
        path: "/forms/create",
        name: "Forms.Create",
        component: CreateForm,
    },

    {
        path: "/forms/:dynamic_form_id/edit",
        name: "Form.Edit",
        component: CreateForm,
    },

    {
        path: "/attendance",
        name: "Attendance",
        component: Attendance,
    },

    // sessiion forms
    {
        path: "/session_forms",
        name: "SessionForms.Index",
        component: SessionForms,
    },
    {
        path: "/session_forms/:school_id/view",
        name: "SessionForm.View",
        component: SessionFormView,
    },

    // Reminders
    {
        path: "/reminders",
        name: "Reminders.View",
        component: Reminders,
    },


];

const router = createRouter({
    history: createWebHashHistory(),
    routes,
});


router.beforeEach(function (to, _, next) {
    // console.log("to--", to)
    // console.log("store.getters.user", store.getters.user)
    if (to.meta.auth && !store.getters.user) {
        next('/');
    }
    else if (to.meta.unAuth && store.getters.user) {
        next('/dashboard');
    }
    else {
        next();
    }
    // else {
    //     let permissions = store.getters.permissions;
    //     if (to.meta.permission == 'All') {
    //         next();
    //     }
    //     else if (permissions.length) {
    //         console.log("case2--", permissions.length)
    //         let permission = permissions.filter(function (el) {
    //             console.log(to.meta.permission)
    //             return el.ability.ability == to.meta.permission || to.meta.permission == 'All';
    //         });
    //         console.log(permission)
    //         if (permission.length) {
    //             next();
    //         }
    //         else {
    //             next('/error')
    //         }
    //     }
    //     else {
    //         next('/error')
    //     }
    // }

});

export default router;
